import { IAplosApiRequestArgs } from "@/services/aplosApi";

export interface GetExecutionOutputPackageArgsOptions {
    userId: string;
    tenantId: string;
    executionId: string;
}

export class GetExecutionOutputPackageArgs implements IAplosApiRequestArgs {
    public userId: string;
    public tenantId: string;
    public executionId: string;

    constructor(options: GetExecutionOutputPackageArgsOptions) {
        if (options.userId == null) throw Error("userId is required");
        if (options.tenantId == null) throw Error("tenantId is required");
        if (options.executionId == null) throw Error("executionId is required");

        this.userId = options.userId;
        this.tenantId = options.tenantId;
        this.executionId = options.executionId;
    }
}
